export default __webpack_public_path__ + "static/media/NAAC A+.10f79886.png";